<app-customfileupload (uploadedFileChanged)="uploadedFileChanged($event)"
                      [allowedFile]="[{ extension: 'xlsx', count: 10 },{ extension: 'dwg', count: 10 },{ extension: 'pdf', count: 10 }]"
                      [allowMultiple]="true"
                      [specificationText]="'[.xlsx/.dwg/ .pdf file]'" #uploadComponent></app-customfileupload>
<div class="card card-default">
  <div class="card-body">
    <button class="btn btn-success" (click)="analyzeFile();" *ngIf="!isButtonSetDisabled">Analyze File</button>
    &nbsp;
    &nbsp;
    <button class="btn btn-danger" (click)="cleanForm();" *ngIf="!isButtonSetDisabled">New Request</button>
    <div class="form-group row" *ngIf="isButtonSetDisabled">
      <div class="col-sm-1 text-right" style="padding-left: 30px">
        <div class="square-spin">
          <div></div>
        </div>
      </div>
      <div class="col-md-11" style="padding-top: 20px">
        <progressbar class="mb-2" [max]="totalFileForBar" [value]="processedFileForBar">
          <span style="color: white; white-space: nowrap;">{{processedFileForBar}} / {{totalFileForBar}}</span>
        </progressbar>
      </div>
    </div>
  </div>
</div>
<div class="card card-default ">
  <div class="card-body">
    <div class="devices-table-container">
      <table class="table">
        <tr *ngFor="let wrapper of documentGeneratorAnalysisWrappers">
          <td>
            <table class="table">
              <tr>
                <td>
                  {{wrapper.disciplineName}}  &nbsp;&nbsp;
                  <button class="btn btn-xs btn-warning" (click)="processDiscipline(wrapper)">Generate documents for this discipline</button>
                </td>
              </tr>
              <tr>
                <td>
                  <table class="table table-hover" id="tableDevices">
                    <tr>
                      <th style="width: 25%;">Device</th>
                      <th style="width: 15%;" class="text-center">Quantity Identified</th>
                      <th style="width: 15%;">
                        <span class="checkbox c-checkbox px-2 pt-1">
                          <label>
                            <input type="checkbox" checked="checked" (click)="checkAll(wrapper, 'firstFile', $event)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label">
                          File 1
                        </label>
                      </th>
                      <th style="width: 15%;">
                        <span class="checkbox c-checkbox px-2 pt-1">
                          <label>
                            <input type="checkbox" checked="checked" (click)="checkAll(wrapper,'secondFile', $event)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label">
                          File 2
                        </label>
                      </th>
                      <th style="width: 15%;">
                        <span class="checkbox c-checkbox px-2 pt-1">
                          <label>
                            <input type="checkbox" checked="checked" (click)="checkAll(wrapper,'thirdFile', $event)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label">
                          File 3
                        </label>
                      </th>
                      <th style="width: 15%;" class="text-center">Files Selected</th>
                    </tr>
                    <tr *ngFor="let documentGeneratorAnalysis of wrapper.documentGeneratorAnalysisList">
                      <td>{{documentGeneratorAnalysis.deviceName}}</td>
                      <td class="text-center">{{documentGeneratorAnalysis.quantityIdentified}}</td>
                      <td>
                        <span class="checkbox c-checkbox px-2 pt-1" *ngIf="documentGeneratorAnalysis.firstFile">
                          <label>
                            <input type="checkbox" [(ngModel)]="documentGeneratorAnalysis.firstFile.isSelected" (change)="calculateSelectedFileCount(documentGeneratorAnalysis)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label file-preview-link" (click)="previewFile(documentGeneratorAnalysis.firstFile)" *ngIf="documentGeneratorAnalysis.firstFile">
                          {{documentGeneratorAnalysis.firstFile.name}}
                        </label>
                      </td>
                      <td>
                        <span class="checkbox c-checkbox px-2 pt-1" *ngIf="documentGeneratorAnalysis.secondFile">
                          <label>
                            <input type="checkbox" [(ngModel)]="documentGeneratorAnalysis.secondFile.isSelected" (change)="calculateSelectedFileCount(documentGeneratorAnalysis)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label file-preview-link" (click)="previewFile(documentGeneratorAnalysis.secondFile)" *ngIf="documentGeneratorAnalysis.secondFile">
                          {{documentGeneratorAnalysis.secondFile.name}}
                        </label>
                      </td>
                      <td>
                        <span class="checkbox c-checkbox px-2 pt-1" *ngIf="documentGeneratorAnalysis.thirdFile">
                          <label>
                            <input type="checkbox" [(ngModel)]="documentGeneratorAnalysis.thirdFile.isSelected" (change)="calculateSelectedFileCount(documentGeneratorAnalysis)" />
                            <span class="fa fa-check file-preview-link"></span>
                          </label>
                        </span>
                        <label class="form-check-label file-preview-link" (click)="previewFile(documentGeneratorAnalysis.thirdFile)" *ngIf="documentGeneratorAnalysis.thirdFile">
                          {{documentGeneratorAnalysis.thirdFile.name}}
                        </label>
                      </td>
                      <td class="text-center">
                        {{documentGeneratorAnalysis.filesSelected}}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 25%;" class="text-center">Device Type Total : {{wrapper.documentGeneratorAnalysisList?wrapper.documentGeneratorAnalysisList.length:0}}</td>
                      <td style="width: 15%;" class="text-center">{{wrapper.totalQuantityIdentified}}</td>
                      <td style="width: 15%;"></td>
                      <td style="width: 15%;"></td>
                      <td style="width: 15%;"></td>
                      <td style="width: 15%;" class="text-center">
                        {{wrapper.totalSelectedFilesCount}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div class="mt-2">
      <button class="btn btn-info" (click)="process()">Generate All</button>
    </div>
  </div>
</div>
<ngx-smart-modal #fileUploadModal identifier="previewModal" customClass='msg-modal'>
  <a href="{{documentDownloadUrl}}" target="_blank">Download</a>
  <iframe [src]="previewDocumentUrl | safeUrl"></iframe>
</ngx-smart-modal>
